import { render, staticRenderFns } from "./PlayLegend.vue?vue&type=template&id=5a6c9235&scoped=true&"
import script from "./PlayLegend.vue?vue&type=script&lang=js&"
export * from "./PlayLegend.vue?vue&type=script&lang=js&"
import style0 from "./PlayLegend.vue?vue&type=style&index=0&id=5a6c9235&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6c9235",
  null
  
)

export default component.exports